/**
 * Canonical list of `viewEvent` types emitted by `BenzaitenCardMediumComponent`.
 * Eagerly importable (no component code) so both the component and any consumer/registry
 * entry can share one source of truth instead of duplicating string literals.
 *
 * First iteration / base only — these events will move to their appropriate location in a
 * later iteration of event exposing. The component must remain self-sufficient and handle
 * these specific events on its own until then.
 */
export const BenzaitenCardEvents = {
  MenuOpened: 'menuOpened',
} as const;

export type BenzaitenCardEventType = (typeof BenzaitenCardEvents)[keyof typeof BenzaitenCardEvents];
